module.exports = __webpack_public_path__ + "img/Historia y Filosofía.4edbd5a0.svg";